var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFsSignet = function SvgFsSignet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FS sygnet + logotyp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.94582C0 1.7666 1.76661 0 3.94582 0H38.0542C40.2334 0 42 1.76661 42 3.94582V31.3731L31.5002 41.8298H3.94582C1.7666 41.8298 0 40.0632 0 37.884V3.94582Z",
    fill: "#E91171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fs",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0551 15.1981C19.6071 15.1981 19.2361 15.3271 18.9421 15.585C18.6481 15.843 18.5011 16.2369 18.5011 16.7667V17.0177H20.5801V19.7994H18.5011V27.6425H14.7001V19.7994H12.7471V17.0177H14.7001V16.7249C14.7001 15.2887 15.0746 14.1663 15.8236 13.3576C16.5726 12.5489 17.6611 12.1445 19.0891 12.1445C19.9011 12.1445 20.5591 12.2421 21.0631 12.4373V15.3445C20.6571 15.2469 20.3211 15.1981 20.0551 15.1981ZM26.208 27.8098C24.08 27.8098 22.4 27.3845 21.168 26.534L22.134 23.9614C22.708 24.3518 23.359 24.6551 24.087 24.8712C24.815 25.0873 25.529 25.1954 26.229 25.1954C26.663 25.1954 26.999 25.1327 27.237 25.0072C27.475 24.8817 27.594 24.7074 27.594 24.4843C27.594 24.2891 27.5065 24.1322 27.3315 24.0137C27.1565 23.8952 26.824 23.7871 26.334 23.6895L24.612 23.2921C23.52 23.0691 22.7325 22.717 22.2495 22.2359C21.7665 21.7549 21.525 21.0891 21.525 20.2386C21.525 19.5553 21.728 18.9488 22.134 18.419C22.54 17.8891 23.1035 17.4743 23.8245 17.1745C24.5455 16.8748 25.375 16.7249 26.313 16.7249C27.083 16.7249 27.839 16.8364 28.581 17.0595C29.323 17.2826 30.016 17.5963 30.66 18.0007L29.652 20.5105C29.092 20.1479 28.518 19.8691 27.93 19.6739C27.342 19.4787 26.789 19.3811 26.271 19.3811C25.851 19.3811 25.522 19.4473 25.284 19.5798C25.046 19.7122 24.927 19.9039 24.927 20.1549C24.927 20.3083 24.997 20.4303 25.137 20.5209C25.277 20.6116 25.543 20.7057 25.935 20.8033L27.72 21.2007C28.854 21.4656 29.6695 21.8525 30.1665 22.3614C30.6635 22.8704 30.912 23.564 30.912 24.4425C30.912 25.4882 30.4955 26.3109 29.6625 26.9104C28.8295 27.51 27.678 27.8098 26.208 27.8098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 41.8298L42 31.3724H31.5V41.8298Z",
    fill: "#7038A7"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFsSignet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fs-signet.21cccd3d.svg";
export { ForwardRef as ReactComponent };